import React from "react";
import { FormControl, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import type { AnswerSet, AnswerValue } from "../../../../../../types/answerSet";
import { toNum } from "./constants";
import type { OperandTypeComponentProps } from "./types";

export interface RightAnswerSameQuestionProps extends OperandTypeComponentProps {
    answerOptions: AnswerValue[];
    loading: boolean;
}

export const RightAnswerSameQuestion: React.FC<RightAnswerSameQuestionProps> = ({
    value,
    onChange,
    answerOptions,
    loading,
}) => {
    const rightAnswerId = value?.value != null ? toNum(value.value) : undefined;
    const getAnswerLabel = (a: AnswerValue) => a.displayText ?? a.name ?? a.tagLabel ?? (a.id != null ? String(a.id) : "");

    return (
        <Stack spacing={1}>
            <FormControl size="small" fullWidth>
                <InputLabel id="right-answer-label">Answer (same question)</InputLabel>
                <Select<number | "">
                    labelId="right-answer-label"
                    label="Answer (same question)"
                    value={rightAnswerId ?? ""}
                    onChange={(e) => {
                        const v = e.target.value;
                        onChange(v === "" ? null : { value: Number(v) });
                    }}
                    displayEmpty
                    renderValue={(v) => {
                        if (v === "" || v == null) return "";
                        const a = answerOptions.find((x) => x.id != null && Number(x.id) === v);
                        return a ? getAnswerLabel(a) : String(v);
                    }}
                >
                    <MenuItem value="">
                        <em>{loading ? "Loading…" : "Select answer"}</em>
                    </MenuItem>
                    {answerOptions.map((a) => (
                        <MenuItem key={a.id ?? a.name ?? a.tagLabel} value={a.id ?? ""}>
                            {getAnswerLabel(a)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Stack>
    );
};
